// extracted by extract-css-chunks-webpack-plugin
module.exports = {"info_box":"info_box-2dImLzLw clearfix","comment":"comment-cJAti2m4","pic":"pic-cZSNApyh","v_logo":"v_logo-3sX8creu","text":"text-2lBQGZAV","time":"time-2zm-aFUM"};